import { Component, Input, HostBinding } from '@angular/core';

type ButtonColor =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral'
  | 'analog'
  | 'contrast';
type ButtonAppearance = 'filled' | 'tonal' | 'basic';
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'button[app-button], a[app-button]',
  template: '<ng-content></ng-content>',
  styleUrls: ['./button.component.scss'],
  standalone: true,
})
export class ButtonComponent {
  @Input() appearance: ButtonAppearance = 'basic';
  @Input() color: ButtonColor;
  @Input() size: ButtonSize = 'sm';

  @HostBinding('class.btn') readonly isButton = true;

  // appearance
  @HostBinding('class.btn--filled') get isFilled() {
    return this.appearance === 'filled';
  }

  @HostBinding('class.btn--tonal') get isTonal() {
    return this.appearance === 'tonal';
  }

  @HostBinding('class.btn--basic') get isBasic() {
    return this.appearance === 'basic';
  }

  // sizes
  @HostBinding('class.btn--xs') get isXs() {
    return this.size === 'xs';
  }
  @HostBinding('class.btn--sm') get isSm() {
    return this.size === 'sm';
  }
  @HostBinding('class.btn--md') get isMd() {
    return this.size === 'md';
  }
  @HostBinding('class.btn--lg') get isLg() {
    return this.size === 'lg';
  }
  @HostBinding('class.btn--xl') get isXl() {
    return this.size === 'xl';
  }

  // colors
  @HostBinding('class.btn--primary') get isPrimary() {
    return this.color === 'primary';
  }

  @HostBinding('class.btn--success') get isSuccess() {
    return this.color === 'success';
  }

  @HostBinding('class.btn--warning') get isWarning() {
    return this.color === 'warning';
  }

  @HostBinding('class.btn--danger') get isDanger() {
    return this.color === 'danger';
  }

  @HostBinding('class.btn--info') get isInfo() {
    return this.color === 'info';
  }

  @HostBinding('class.btn--neutral') get isNeutral() {
    return this.color === 'neutral';
  }

  @HostBinding('class.btn--analog') get isAnalog() {
    return this.color === 'analog';
  }

  @HostBinding('class.btn--contrast') get isContrast() {
    return this.color === 'contrast';
  }
}
